var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVector = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 1.42182L1.46461 17.2562C1.39093 17.3896 1.35962 17.5422 1.37485 17.6938C1.39009 17.8455 1.45114 17.9888 1.54989 18.1049C1.64863 18.2209 1.78039 18.3042 1.92761 18.3435C2.07483 18.3828 2.23053 18.3763 2.37399 18.3249L10.7365 15.3437C10.8988 15.278 11.0804 15.278 11.2427 15.3437L19.6052 18.3249C19.7487 18.3763 19.9044 18.3828 20.0516 18.3435C20.1988 18.3042 20.3306 18.2209 20.4293 18.1049C20.5281 17.9888 20.5891 17.8455 20.6044 17.6938C20.6196 17.5422 20.5883 17.3896 20.5146 17.2562L11.6459 1.42182C11.581 1.30459 11.4859 1.20688 11.3705 1.13884C11.2551 1.0708 11.1236 1.03491 10.9896 1.03491C10.8556 1.03491 10.7241 1.0708 10.6087 1.13884C10.4933 1.20688 10.3982 1.30459 10.3334 1.42182Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVector);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vector.0739f45e94feda781e8716b2475517c0.svg";